import React from 'react'
import { When } from 'react-if'
import { LinkButton } from '@/atoms/Button'
import { GuildIconMono } from '@/atoms/Icons/GuildIconMono'
import { ParagraphSM, TitleSM } from '@/atoms/Text'
import { paths } from '@/constants'
import { ProjectDetails } from '@/services/ProjectsService'
import { projectThemes } from '@/utils/project-themes'
import { useTranslate } from '@/utils/translate/translate-client'

interface JoinTheGuildSectionProps {
  onClick?: () => void
  project: ProjectDetails
}

export const JoinTheGuildSection: React.FC<JoinTheGuildSectionProps> = ({ onClick, project }) => {
  const { t } = useTranslate('guild')

  const name = projectThemes[project.slug]?.name ?? 'Angel Studios'
  const projectName = name !== 'Angel Studios'
  const projectType = project?.projectType === 'series' ? t('shows', 'shows') : t('films', 'films')

  return (
    <div className="rounded-lg border border-gray-200 bg-gray-100 p-6 text-black lg:p-10">
      <div className="flex w-full flex-col gap-4 md:gap-6">
        <div className="flex items-center gap-3 align-middle">
          <div className="flex h-10 w-10 items-center justify-center rounded-3xl bg-oxide-primary pt-1 align-middle">
            <GuildIconMono color="white" className="m-auto" size={26} />
          </div>
          <div>
            <TitleSM weight="bold" className="md:photon-title-md lg:photon-title-lg" color="core-gray-950">
              {t('joinTheGuildUnlockStorytelling', 'Join the Guild to Unlock Masterful Storytelling.')}
            </TitleSM>
            <TitleSM weight="bold" className="md:photon-title-md lg:photon-title-lg" color="core-gray-950">
              {t('joinTheGuildTransformIndustry', 'Help Transform the Industry.')}
            </TitleSM>
          </div>
        </div>
        <ParagraphSM className="md:photon-title-md text-pretty" color="core-gray-800" weight="medium">
          <When condition={projectName}>
            {t(
              'yourMembershipDirectlyContributes',
              'Your membership directly contributes to the production of {{ projectType }} like {{ name }}, allowing filmmakers to tell more stories that uplift, entertain, and amplify light.',
              {
                projectType,
                name,
              },
            )}
          </When>
          <When condition={!projectName}>
            {t(
              'joinMissionInfuseIndustry',
              `Join our mission to infuse the industry with high-quality, uplifting entertainment the whole family can enjoy. Angel Studios’ library is filled with movies and shows that don’t just entertain, but inspire you to lead a better life.`,
            )}
          </When>
        </ParagraphSM>
        <div className="grid grid-cols-2 gap-8 align-middle">
          <LinkButton
            className="w-fit border-0 bg-oxide-primary"
            href={`${paths.guild.join}/${project.slug}`}
            onClick={onClick}
            variant={'oxide'}
            prefetch={false}
          >
            <div className="mx-auto whitespace-nowrap text-center">{t('joinTheGuild', 'Join the Guild')}</div>
          </LinkButton>
        </div>
      </div>
    </div>
  )
}
